import NewspaperAdvancedForm from './NewspaperAdvancedForm'

export default NewspaperAdvancedForm
